import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useLocationContext } from '../../location.context';

export const LocationDeleteFormStep1Controller = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const location = useLocationContext();

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <>
      <Text bold>
        {t('$.location-delete.step-1.confirm', {
          name: location.name,
        })}
      </Text>
      <Text italic>{t('$.location-delete.step-1.warning')}</Text>
    </>
  );
};
